var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g(_vm._b({},'div',_vm.$attrs,false),_vm.$listeners),[(_vm.title)?_c('div',{staticClass:"font-weight-bold",domProps:{"textContent":_vm._s(_vm.title)}}):_vm._e(),_vm._l((_vm.conditions),function(condition,conditionIdx){return _c('div',{key:conditionIdx,class:{
		'mt-1': true,
		'success--text': condition.valid,
		'danger--text': !condition.valid,
	}},[(condition.valid)?_c('v-icon',{attrs:{"color":"success","left":""}},[_vm._v("mdi-check")]):_c('v-icon',{attrs:{"color":"error","left":""}},[_vm._v("mdi-close")]),_c('span',{domProps:{"textContent":_vm._s(condition.text)}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }